<template>
  <section class="wh_container">
    <div class="wh_content_all">
      <div class="wh_top_changge">
        <li class="wh_content_li">{{dateTop}}</li>
        <div class="wh_content_jiantouwrapper">
          <li @click="PreMonth(myDate,false)" class="wh_content_jiantou1">
            <div class="wh_jiantou1"></div>
          </li>
          <li @click="NextMonth(myDate,false)">
            <div class="wh_jiantou2"></div>
          </li>
        </div>
      </div>
      <div class="wh_content wh_content_week">
        <div class="wh_content_item" v-for="tag in textTop">
          <div class="wh_top_tag">
            {{tag}}
          </div>
        </div>
      </div>
      <div class="wh_content">
        <div class="wh_content_container">
          <div class="wh_content_item" v-for="(item, index) in dayList" @click="clickDay(item,index)">
            <div class="wh_item_date" v-bind:class="[{ wh_isMark: item.isMark},{wh_other_dayhide:item.otherMonth!=='nowMonth'},{wh_want_dayhide:item.dayHide},{wh_isToday:item.isToday},{wh_chose_day:item.chooseDay},setClass(item), {wh_has_detail: item.otherMonth==='nowMonth'&&item.busi&&item.busi.length}]">
              <span class="wh_item_date_span" :class="item.otherMonth==='nowMonth'&&item.busi&&item.busi.length?'has_detail':''">{{!isDisplayOtherMonthDay && item.otherMonth !== 'nowMonth' ? '' : item.id}}</span>
            </div>
            <!-- 小圆点 -->
            <!-- <div class="circle" v-if="item.otherMonth!=='preMonth'&&item.busi&&item.busi.length"></div> -->
            <div class="wh_content_item_data" v-if="item.busi">
              <div class="triangle"></div>
              <a class="wh_content_item_data_li" :href="`/event/${item.id}`" v-for="(item, idx) in item.busi" target="_blank" :key="idx">
                <div class="circle"></div>
                <p class="wh_item_data_title">{{item.title}}</p>
                <p class="wh_item_data_time">{{`${formateTime(item.begin_time)}-${formateTime(item.end_time)}`}}</p>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import timeUtil from './calendar'
import moment from 'moment'
export default {
  data() {
    return {
      myDate: [],
      dayList: this.list,
      historyChose: [],
      dateTop: ''
    }
  },
  props: {
    markDate: {
      type: Array,
      default: () => []
    },
    markDateMore: {
      type: Array,
      default: () => []
    },
    textTop: {
      type: Array,
      default: () => ['日', '一', '二', '三', '四', '五', '六']
    },
    sundayStart: {
      type: Boolean,
      default: () => false
    },
    agoDayHide: { type: String, default: `0` },
    futureDayHide: { type: String, default: `2554387200` },
    isDisplayOtherMonthDay: { type: Boolean, default: false },
    list: {
      type: Array,
      default: () => []
    },
    // 是否开启点击选中功能
    clickable: {
      type: Boolean,
      default: () => false
    }
  },
  created() {
    this.intStart()
    this.myDate = new Date()
  },
  methods: {
    intStart() {
      timeUtil.sundayStart = this.sundayStart
    },
    setClass(data) {
      let obj = {}
      obj[data.markClassName] = data.markClassName
      return obj
    },
    clickDay: function (item, index) {
      if (!this.clickable) return
      if (item.otherMonth === 'nowMonth' && !item.dayHide) {
        this.getList(this.myDate, item.date)
      }
      if (item.otherMonth !== 'nowMonth') {
        item.otherMonth === 'preMonth'
          ? this.PreMonth(item.date)
          : this.NextMonth(item.date)
      }
    },
    ChoseMonth: function (date, isChosedDay = true) {
      date = timeUtil.dateFormat(date)
      this.myDate = new Date(date)
      this.$emit('changeMonth', timeUtil.dateFormat(this.myDate))
      if (isChosedDay) {
        this.getList(this.myDate, date, isChosedDay)
      } else {
        this.getList(this.myDate)
      }
    },
    PreMonth: function (date, isChosedDay = true) {
      date = timeUtil.dateFormat(date)
      this.myDate = timeUtil.getOtherMonth(this.myDate, 'preMonth')
      this.$emit('changeMonth', this.myDate)
      if (isChosedDay) {
        this.getList(this.myDate, date, isChosedDay)
      } else {
        this.getList(this.myDate)
      }
    },
    NextMonth: function (date, isChosedDay = true) {
      date = timeUtil.dateFormat(date)
      this.myDate = timeUtil.getOtherMonth(this.myDate, 'nextMonth')
      this.$emit('changeMonth', this.myDate)
      if (isChosedDay) {
        this.getList(this.myDate, date, isChosedDay)
      } else {
        this.getList(this.myDate)
      }
    },
    forMatArgs: function () {
      let markDate = this.markDate
      let markDateMore = this.markDateMore
      markDate = markDate.map((k) => {
        return timeUtil.dateFormat(k)
      })
      markDateMore = markDateMore.map((k) => {
        k.date = timeUtil.dateFormat(k.date)
        return k
      })
      return [markDate, markDateMore]
    },
    getList: function (date, chooseDay, isChosedDay = true) {
      const [markDate, markDateMore] = this.forMatArgs()
      this.dateTop = `${date.getFullYear()}年${date.getMonth() + 1}月`
      let arr = timeUtil.getMonthList(this.myDate)
      for (let i = 0; i < arr.length; i++) {
        let markClassName = ''
        let k = arr[i]
        k.chooseDay = false
        const nowTime = k.date
        const t = new Date(nowTime).getTime() / 1000
        //看每一天的class
        for (const c of markDateMore) {
          if (c.date === nowTime) {
            markClassName = c.className || ''
          }
        }
        //标记选中某些天 设置class
        k.markClassName = markClassName
        k.isMark = markDate.indexOf(nowTime) > -1
        //无法选中某天
        k.dayHide = t < this.agoDayHide || t > this.futureDayHide
        if (k.isToday) {
          this.$emit('isToday', nowTime)
        }
        let flag = !k.dayHide && k.otherMonth === 'nowMonth'
        if (chooseDay && chooseDay === nowTime && flag) {
          this.$emit('choseDay', nowTime)
          this.historyChose.push(nowTime)
          k.chooseDay = true
        } else if (
          this.historyChose[this.historyChose.length - 1] === nowTime && !chooseDay && flag
        ) {
          k.chooseDay = true
        }
      }
      this.dayList = arr
      this.$emit('setDaysList', { date: date || moment().format('YYYY-MM-DD'), lists: arr || [] })
    },
    formateTime (time) {
      return moment(Number(time) * 1000).format('HH:mm')
    }
  },
  mounted() {
    this.getList(this.myDate)
  },
  watch: {
    markDate: {
      handler(val, oldVal) {
        this.getList(this.myDate)
      },
      deep: true
    },
    markDateMore: {
      handler(val, oldVal) {
        this.getList(this.myDate)
      },
      deep: true
    },
    agoDayHide: {
      handler(val, oldVal) {
        this.agoDayHide = parseInt(val)
        this.getList(this.myDate)
      },
      deep: true
    },
    futureDayHide: {
      handler(val, oldVal) {
        this.futureDayHide = parseInt(val)
        this.getList(this.myDate)
      },
      deep: true
    },
    sundayStart: {
      handler(val, oldVal) {
        this.intStart()
        this.getList(this.myDate)
      }, deep: true
    },
    list: {
      handler (n, o) {
        this.dayList = n
      },
      deep: true
    }
  }
}
</script>
<style scoped lang="scss">

$primary-color: #D7B375;
$bgc-color: #282D32;

$week-color: #AFB1C6;
$date-hover-color: #282D32;
$today-color: #D7B375;
$chose-day-color: #282D32;

$item-date-size: 30px;
$item-date-line-height: 43px;

$wh_other_dayhide: rgba(136, 136, 136, .4); // 当月里上个月份与下个月份的显示
$wh_want_dayhide: rgba(136, 136, 136, .4); // 未来的月份显示

@media screen and (min-width: 460px) {
  .wh_has_detail:hover {
    background: $date-hover-color;
    cursor: pointer;
    border-radius: 200px;
  }
}
* {
  margin: 0;
  padding: 0;
}

.wh_container {
  max-width: 410px;
  margin: auto;
}

li {
  list-style-type: none;
}
.wh_top_changge {
  display: flex;
  justify-content: space-between;
  padding: 24px 23px 14px 13px;
}

.wh_top_changge li {
  cursor: pointer;
  display: flex;
  flex-wrap: nowrap;
  color: #fff;
  font-size: 18px;
  justify-content: center;
  align-items: center;
}

.wh_top_changge .wh_content_li {
  cursor: auto;
  color: $primary-color;
  font-weight: 600;
  font-size: 24px;
  line-height: 24px;
}

.wh_top_changge .wh_content_jiantouwrapper {
  display: flex;
  .wh_content_jiantou1 {
    margin-right: 18px;
  }
}

.wh_content_all {
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC",
    "Helvetica Neue", STHeiti, "Microsoft Yahei", Tahoma, Simsun, sans-serif;
  background-color: $bgc-color;
  width: 100%;
  border-radius: 5px
  // overflow: hidden;
}

.wh_content {
  display: flex;
  flex-wrap: wrap;
  padding: 0 20px;
  width: 100%;
  &.wh_content_week {
    .wh_content_item {
      color: $week-color;
      font-size: 17px;
      border-bottom: 1px solid rgba(136, 136, 136, .2);
    }
  }
}

.wh_content_container {
  display: flex;
  flex-wrap: wrap;
  padding: 3px 0;
  border-bottom: 1px solid rgba(136, 136, 136, 0.2);
}

.wh_content:first-child .wh_content_item_tag,
.wh_content:first-child .wh_content_item {
  color: #ddd;
  font-size: 16px;
}

.wh_content_item,
wh_content_item_tag {
  font-size: 15px;
  width: 14.28%;
  text-align: center;
  color: #fff;
  position: relative;
}
.wh_content_item {
  height: $item-date-line-height;
  position: relative;
  display: flex;
  align-items: center;
}

.wh_content_item:hover {
  .wh_content_item_data {
    display: block;
  }
}

// 小圆点
.circle {
  position: absolute;
  bottom: 6px;
  left: 50%;
  transform: translateX(-50%);
  width: 4px;
  height: 4px;
  border-radius: 2px;
  background-color: $primary-color;
}

// hover 背景图
.wh_content_item_data {
  display: none;
  position: absolute;
  z-index: 100000;
  top: calc(100% + 10px);
  transform: translateX(calc(-50% + 22px));
  background-color: #fff;
  width: 228px;
  padding: 24px 24px 24px 32px;
  color: #353535;
  border-radius: 5px;
  text-align: left;
  box-shadow: 0 8px 16px 0 rgba(7, 17, 27, .2);
  // 三角形
  .triangle {
    width: 0;
    height: 0;
    border-top: 18px solid #fff;
    border-left: 18px solid transparent;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, -50%) rotateZ(-45deg);
  }
  .wh_content_item_data_li {
    display: block;
    color: #353535;
    position: relative;
    border-bottom: 1px solid rgba(215, 179, 117, .2);
    padding-bottom: 12px;
    margin-bottom: 12px;
    &.no-border {
      border: none;
    }
    &:last-child {
      padding-bottom: 0;
      margin-bottom: 0;
      border: none;
      .wh_item_data_time {
        padding-bottom: 0;
      }
    }
    .circle {
      top: 4px;
      left: -10px;
      width: 8px;
      height: 8px;
      border-radius: 4px;
    }
    .wh_item_data_title {
      font-size: 14px;
      line-height: 15px;
      height: 15px;
      display: -webkit-box;
      text-overflow: ellipsis;
      /*! autoprefixer: ignore next */
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      overflow: hidden;
      transition: all .3s ease;
      &:hover {
        color: $primary-color;
      }
      &.no-link {
        color: rgba(178, 178, 178, 0.5);
      }
    }
    .wh_item_data_time {
      font-size: 13px;
      line-height: 13px;
      padding-top: 10px;
      color: rgba(136, 136, 136, 1);
    }
  }
}

.wh_top_tag {
  width: $item-date-size;
  height: $item-date-size;
  line-height: $item-date-size;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.wh_item_date {
  width: $item-date-size;
  height: $item-date-size;
  // line-height: $item-date-size;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  .wh_item_date_span.has_detail {
    border-bottom: 2px solid $primary-color;
  }
}

.wh_jiantou1 {
  width: 12px;
  height: 12px;
  border-top: 2px solid $primary-color;
  border-left: 2px solid $primary-color;
  transform: rotate(-45deg);
}

.wh_jiantou1:active,
.wh_jiantou2:active {
  border-color: #ddd;
}

.wh_jiantou2 {
  width: 12px;
  height: 12px;
  border-top: 2px solid $primary-color;
  border-right: 2px solid $primary-color;
  transform: rotate(45deg);
}
.wh_content_item > .wh_isMark {
  margin: auto;
  border-radius: 100px;
  background: blue;
  z-index: 2;
}
.wh_content_item .wh_other_dayhide {
  color: $wh_other_dayhide;
}
.wh_content_item .wh_want_dayhide {
  color: $wh_want_dayhide;
}
.wh_content_item .wh_isToday {
  background: $today-color;
  border-radius: 100px;
}
.wh_content_item .wh_chose_day {
  background: $chose-day-color;
  border-radius: 100px;
}
</style>